import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import FormikSearchableDropdown from './FormikSearchableDropdown';
import { toast } from 'react-toastify';
import { reAssign } from '../services/project/userService';
import { getApprovers } from '../services/project/approverService';
import { useParams } from 'react-router-dom';
import { useProjects } from '../context/ProjectContext';

const ReassignModal = ({ user, roles, show, onClose, onReassign }) => {
  const { projects } = useProjects();
  const { projectId } = useParams();
  const project = projects?.find(p => String(p.id) === String(projectId));
  const [roleId, setRoleId] = useState('');
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState('');
  const [approverFormik, setApproverFormik] = useState({ values: { approverId: '' }, setFieldValue: () => {}, touched: {}, errors: {} });

  // projectId already defined above
  useEffect(() => {
    if (user) {
      setRoleId(user.roles[0].id || '');
      if (user.approverId) {
        setSelectedApprover(String(user.approverId));
        setApproverFormik(f => ({
          ...f,
          values: { ...f.values, approverId: String(user.approverId) }
        }));
      }
    }
  }, [user]);

  useEffect(() => {
    console.log(project.settings)
    if (project?.settings?.approval && projectId) {
      getApprovers(projectId).then(setApprovers).catch(() => setApprovers([]));
    }
  }, [project]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!roleId) {
      toast.error('Please select both role and area.');
      return;
    }
    if (project?.settings?.approval && !approverFormik.values.approverId) {
      toast.error('Please select an approver.');
      return;
    }

    try {
      const { success, message, errorMessage } = await reAssign(
        user.id,
        roleId,
        user.roles[0].id,
        projectId,
  project?.settings?.approval && approverFormik.values.approverId ? parseInt(approverFormik.values.approverId, 10) : undefined
      );
      if (!success) {
        toast.error(errorMessage || 'Something went wrong');
      }
      toast.success(message);
      onReassign();
      onClose();
    } catch (error) {
      console.error('Role error:', error);
      toast.error(error?.response?.data?.errorMessage || 'Something went wrong');
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      fullscreen="md-down"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Reassign {user?.firstName} {user?.lastName} </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Role</Form.Label>
            <Form.Select
              value={roleId}
              onChange={(e) => {
                setRoleId(e.target.value);
              }}
            >
              <option value="">Select Role</option>
              {roles
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          {project?.settings?.approval && (
            <FormikSearchableDropdown
              label="Approver"
              name="approverId"
              options={approvers.map(a => ({ value: String(a.id), label: a.fullName }))}
              isMulti={false}
              formik={{
                values: approverFormik.values,
                setFieldValue: (field, value) => setApproverFormik(f => ({ ...f, values: { ...f.values, [field]: value } })),
                touched: approverFormik.touched,
                errors: approverFormik.errors,
              }}
            />
          )}
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onClose} className="me-2">
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ReassignModal;
